module.exports = __webpack_public_path__ + "img/bg-certification.f1271470.png";